import * as React from 'react';
import { Context, useContext, useState } from 'react';

export type WrokspacesInitializationContextProps = {
  isInitialized: boolean;
  setIsInitialized: (initialized: boolean) => void;
  activeWorkspaceId?: string;
  setActiveWorkspaceId: (workspaceId: string | undefined) => void;
};

export const defaultWorkspacesInitializationContextProps: WrokspacesInitializationContextProps =
  {
    isInitialized: false,
    setIsInitialized: (_initialized: boolean) => {},
    activeWorkspaceId: undefined,
    setActiveWorkspaceId: (_workspaceId: string | undefined) => {},
  };

export const WorkspacesInitializationContext: Context<WrokspacesInitializationContextProps> =
  React.createContext(defaultWorkspacesInitializationContextProps);

export const useWorkspaceInitializationContext =
  (): WrokspacesInitializationContextProps => {
    return useContext(WorkspacesInitializationContext);
  };

export const WorkspaceInitializationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [activeWorkspaceId, setActiveWorkspaceId] = useState<
    string | undefined
  >(undefined);

  return (
    <WorkspacesInitializationContext.Provider
      value={{
        isInitialized,
        setIsInitialized,
        activeWorkspaceId,
        setActiveWorkspaceId,
      }}
    >
      {children}
    </WorkspacesInitializationContext.Provider>
  );
};
